import { urlParams } from "../../constants/AppConstants";

export let ZenDesk_External = {
  service: "Zendesk",
  showSideBar: true,
  showSideBarForcefully: true,
  inboxSendSMS: false,
  sideBarExtend: {
    customModuleTab: false,
  },
  workFlowIconInTemplates: true,
  landingPage: true,
  landingPagePathname: "/zendesk/landing",
  createLeadOrContactName: "Create Contact",
  SMS_GALLERY: [
    {
      videoUrl: "https://www.youtube.com/embed/AAKbzpdPStA",
    },
    {
      videoUrl: "https://www.youtube.com/embed/YU49UlzFTZw",
    },
    {
      videoUrl: "https://www.youtube.com/embed/f24zG7tPHLE",
    },
  ],
  VOICE_GALLERY: [
    {
      videoUrl: "https://www.youtube.com/embed/tbvIB0WfFVQ",
    },
    {
      videoUrl: "https://www.youtube.com/embed/s_actXvJJHY",
    },
  ],
  WHATSAPP_GALLERY: [
    {
      headline: "Boost Sales with Direct WhatsApp Messaging in Zendesk",
      sourceUrl: "https://www.youtube.com/embed/Wtvb0a4FCis?si=wbH3DxkMm5IlZOFE",
      steps: ["Send WhatsApp messages to Zendesk prospects ", `Track all conversation history within Zendesk`],
    },
    {
      headline: `Automate SMS and WhatsApp Reminders from Zendesk with HelloSend`,
      sourceUrl: "https://www.youtube.com/embed/BVLCy3R6C6E?si=CWHOgwAKK7eKaxpY",
      steps: ["Save WhatsApp templates and turn on automation", `Drive more sales through engagement`],
    },
    {
      headline: `Automate SMS / WhatsApp message When Deal Stages Change in Zendesk`,
      sourceUrl: "https://www.youtube.com/embed/41GWpzW8jXw?si=8Yn0cLu8HMVIy_jS",
      steps: ["Send templated messages based on deal stage", `Engage at the right time and boost conversions`],
    },
  ],
  automationPageHelpVideo: [
    {
      headline: "Automate SMS / WhatsApp messages  for Deal Stage Changes",
      sourceUrl: "https://www.youtube.com/embed/41GWpzW8jXw?si=4zKwo2AKhpJ2Vwpu",
      steps: ["Send automatic messages to clients when deals progress in Zendesk"],
    },
    {
      headline: "Automate SMS / WhatsApp messages on Specific Date in Zendesk",
      sourceUrl: "https://www.youtube.com/embed/BEifAzENT_M",
      steps: ["Send automatic SMS / WhatsApp reminders for important dates like appointments, renewals, and more"],
    },
    {
      headline: "Automate SMS / WhatsApp Reminders from Zendesk",
      sourceUrl: "https://www.youtube.com/embed/BVLCy3R6C6E",
      steps: ["Set up automatic SMS / WhatsApp reminders for meetings directly in Zendesk"],
    },
    {
      headline: "Automate welcome SMS / WhatsApp messages  to your new leads in Zendesk",
      sourceUrl: "https://www.youtube.com/embed/YU49UlzFTZw",
      steps: ["Automate sending welcome SMS / WhatsApp messages to leads as soon as they're added to Zendesk."],
    },
    {
      headline: "Configuring SMS / WhatsApp Automation",
      sourceUrl: "https://www.youtube.com/embed/g2G-HGeOiyI?si=Wouh6BQfScDbaqEi",
      steps: ["Learn how to set up automatic SMS / WhatsApp notification in 2 simple steps"],
    },
    {
      headline: `Automate SMS / WhatsApp messages in Zendesk`,
      sourceUrl: "https://www.youtube.com/embed/g2G-HGeOiyI?si=Wouh6BQfScDbaqEi",
      steps: [`Learn to automate SMS / WhatsApp messages in Zendesk for your business needs.`],
    },
  ],
  pricingLink: function (appProperties) {
    return new Promise((resolve, reject) => {
      const { hash, osyncId, domain, companyId, userId, leftServiceName, installedApps, randomIntegId } = appProperties;
      const integIds = installedApps?.map((integration) => integration?.integProps?.integId);
      var leftServiceId = urlParams.get("leftServiceId");
      var allUrlParams = getAllUrlParams();
      const decodedParams = decodeURIComponent(allUrlParams);
      let paramsObject = JSON.parse(decodedParams);
      if (paramsObject.service === "zendesk") {
        paramsObject.service = "zendesk_external";
        paramsObject.domain = companyId;
        paramsObject.userId = userId;
        paramsObject.companyId = companyId;
      }
      const updatedUrlParams = encodeURIComponent(JSON.stringify(paramsObject));

      var serviceOrigin = urlParams.get("serviceOrigin");
      var hrefUrl = `/pricing?productId=102&groupName=OMNI_CHANNEL&domain=${domain}&hash=${hash}&leftServiceId=${leftServiceId}&osyncId=${osyncId}&urlParams=${updatedUrlParams}&companyId=${companyId}&userId=${userId}&integIds=${integIds}&serviceOrigin=${serviceOrigin}&service=${leftServiceName}`;

      resolve(hrefUrl);
    });
  },
  getUrlParamsForRedirection: function (isNewWindow, appProperties) {
    return new Promise((resolve, reject) => {
      const urlParams = new URLSearchParams(window.location.search);
      urlParams.delete("sideBar");
      urlParams.delete("topBar");
      urlParams.delete("fullView");
      urlParams.delete("source");

      let rightServiceId = appProperties?.rightServiceId;
      if (isNewWindow) {
        urlParams.delete("service");
        urlParams.append("service", "zendesk_external");
      }
      if (!rightServiceId) {
        rightServiceId = urlParams.get("rightServiceId");
      }
      if (rightServiceId) {
        urlParams.delete("rightServiceId");
        urlParams.append("rightServiceId", rightServiceId);
      }

      let companyId = appProperties?.companyId || urlParams.get("companyId");
      if (companyId) {
        urlParams.delete("companyId");
        urlParams.append("companyId", companyId);
      }

      let userId = appProperties?.userId || urlParams.get("userId");
      if (userId) {
        urlParams.delete("userId");
        urlParams.append("userId", userId);
      }

      console.log("urlParams>>>>Controller (before userData)", urlParams.toString());

      // Only resolve after getUserData() finishes
      appProperties?.controller?.getUserData().then((userData) => {
        urlParams.append("domain", userData.domainName);
        resolve(urlParams.toString());
      });
    });
  },
  getUserData: function () {
    var companyId = urlParams.get("companyId");
    var emailId = urlParams.get("email");
    var userId = urlParams.get("userId");
    var domainName = urlParams.get("domain");
    var companyOrgId = companyId;
    return new Promise((resolve, reject) => {
      var userData = {
        companyId: companyId,
        userId: userId,
        companyOrgId: companyOrgId,
        domainName: domainName,
        emailId: emailId,
      };
      resolve(userData);
    });
  },
  getSettingPreference: function () {
    return new Promise((resolve, reject) => {
      const excludedSettings = ["emailNotification"];

      // Add settingsToInclude for Controller specific settings
      resolve({
        settingsToExclude: excludedSettings,
      });
    });
  },
};

function getAllUrlParams() {
  var allUrlParams = new URLSearchParams(window.location.search);
  var resourceObj = {};
  for (var key of allUrlParams.keys()) {
    resourceObj[key] = allUrlParams.get(key);
  }
  var resourceStr = JSON.stringify(resourceObj);
  return encodeURIComponent(resourceStr);
}
